import blog1 from "../../images/blog/blog-01.jpg";
import blog2 from "../../images/blog/blog-02.jpg";
import blog3 from "../../images/blog/blog-03.jpg";
import blog4 from "../../images/blog/blog-04.jpg";
import blog5 from "../../images/blog/blog-05.jpg";
import blog6 from "../../images/blog/blog-06.jpg";

const data = {
  posts: [
    {
      thumbnail: blog1,
      author: "Code4rest",
      title: "Bitcoin Takes on the Fed: Is a Historic Rally on the Horizon?",
      excerpt: "The prices of cryptocurrency businesses’ shares rose sharply last month, while the index of stocks…",
      timeStamp: "18 January , 2024",
    },
    {
      thumbnail: blog2,
      author: "Code4rest",
      title: "Countdown to ‘most anticipated event in history’",
      excerpt: "Mushe token (XMU) is creating an innovative ecosystem to strengthen, educate and promote…",
      timeStamp: "18 January , 2024",
    },
    {
      thumbnail: blog3,
      author: "Code4rest",
      title: "Eye-opening guide to product review scraping in 2023",
      excerpt: "It unveiled iPhone 15 series phones with expected changes. All four phones have a USB-C…",
      timeStamp: "18 January , 2024",
    },
    {
      thumbnail: blog4,
      author: "Code4rest",
      title: "The Importance of Decentralized Financial Infrastructure",
      excerpt: "The logical solution seems like converting the collapsed currency into some other currency, but…",
      timeStamp: "18 January , 2024",
    },
    {
      thumbnail: blog5,
      author: "Code4rest",
      title: "The Different Types of Cryptocurrency and Tokens?",
      excerpt: "In 2008, an anonymous developer known as Satoshi Nakamoto published a whitepaper describing the first…",
      timeStamp: "18 January , 2024",
    },
    {
      thumbnail: blog6,
      author: "Code4rest",
      title: "Global stocks close near record highs ahead of New Year",
      excerpt: "The aim of the Impact-weighted Accounts is to introduce “line items on a financial statement,…",
      timeStamp: "18 January , 2024",
    },
  ],
};

export default data;
